import { render, staticRenderFns } from "./CustomBarcodeList.vue?vue&type=template&id=ec6e5f20&scoped=true"
import script from "./CustomBarcodeList.vue?vue&type=script&lang=js"
export * from "./CustomBarcodeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6e5f20",
  null
  
)

export default component.exports